/*
 * Copyright (c) 2025.
 * The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";

interface TableHeadWrapperProps {
    children: React.ReactNode | React.ReactNode[];
}

const TableHeadWrapper = (props: TableHeadWrapperProps) => {
    return <thead className={"font-medium border-b-2 border-gray-200 bg-gray-50 text-gray-900 sticky top-0 z-[1] select-none"}>{props.children}</thead>;
};

export default TableHeadWrapper;
